import {basePath} from './global';

//On enregistre un brouillon du formulaire a etre utilisé plus tard
if ($('main.candidat-artiste').length > 0) {

    $(window).on("unload", function (e) {

        let arts = $('textarea#arts').val();
        let info = $('textarea#informations').val();
        let exp = $('textarea#experiences').val();
        let rdv1 = $('input#rdv1').is(':checked');
        let rdv1Text = $('input#rdv1').val();
        let rdv2 = $('input#rdv2').is(':checked');
        let rdv2Text = $('input#rdv2').val();
        let rdv3 = $('input#rdv3').is(':checked');
        let rdv3Text = $('input#rdv3').val();
        let exposerOui = $('input#exposer_oui').is(':checked');
        let exposerNon = $('input#exposer_non').is(':checked');
        let preciser = $('#preciser').val();
        let years = $('#years').val();
        let candidater = $('select#candidater').val();
        let userId = $('input#user-id').val();

        let data = {
            'arts': arts,
            'info': info,
            'exp': exp,
            'rdv1': rdv1,
            'rdv1Text': rdv1Text,
            'rdv2': rdv2,
            'rdv2Text': rdv2Text,
            'rdv3': rdv3,
            'rdv3Text': rdv3Text,
            'exposerOui': exposerOui,
            'exposerNon': exposerNon,
            'preciser' : preciser,
            'years' : years,
            'candidater': candidater,
            'userId': userId
        }

        $.ajax({
            method: "POST",
            url: basePath + "ajax/save-candidat-form",
            data: data,
        })
    });
}


// WEBPACK FOOTER //
// ./src/js/app/candidature-artiste.js